import React from 'react';
import { Button, Text } from '@chakra-ui/react';
import { useForm } from 'react-hook-form';
import MyProfile from '../../MyProfile';
import { InputText, Loader } from '../../../../components';
import {
	MyProfileForm,
	profileResolver,
} from './validation/profile.validation';
import { useEditCurrentUser, useGetCurrentUser } from '../../queries';

export const NameForm = () => {
	const { data: userData, isLoading } = useGetCurrentUser();

	const {
		register,
		formState: { errors },
		handleSubmit,
	} = useForm<MyProfileForm>({
		resolver: profileResolver,
	});

	const { mutate, isPending: isMutationLoading } = useEditCurrentUser();

	if (isLoading) {
		return <Loader centerHeight={'100dvh'} />;
	}

	const onSubmit = (data: MyProfileForm) => {
		mutate({
			...data,
			phoneNumber: userData?.phoneNumber
				? String(userData.phoneNumber)
				: '',
		});
	};

	return (
		<form onSubmit={handleSubmit(onSubmit)}>
			<MyProfile>
				<Text color={'blue.200'}>
					The name will be displayed in your account
				</Text>
				<InputText
					focusBorderColor="#08BB4B"
					{...register('firstName')}
					autoComplete="given-name"
					autoCapitalize="words"
					errorMsg={errors.firstName?.message}
					borderRadius={'10px'}
					h={'55px'}
					bg={'#F1F4F9'}
					label={'First Name'}
					placeholder={userData?.firstName}
				/>
				<InputText
					focusBorderColor="#08BB4B"
					borderRadius={'10px'}
					{...register('lastName')}
					autoComplete="family-name"
					autoCapitalize="words"
					errorMsg={errors.lastName?.message}
					h={'55px'}
					bg={'#F1F4F9'}
					label={'Last Name'}
					placeholder={userData?.lastName}
				/>
				<Button
					type={'submit'}
					h={'60px'}
					isDisabled={isMutationLoading}
					bg={'success'}
					color={'white'}>
					Change Name
				</Button>
			</MyProfile>
		</form>
	);
};
